import {Pipe, PipeTransform} from '@angular/core';
import {FormatService} from "../../dashboard/services/format.service";
import {NumberDisplayType} from "../../dashboard/models/chart";

@Pipe({
  name: 'blankValue',
})
export class BlankValuePipe implements PipeTransform {

  transform(value: any, numbersDisplayType?: NumberDisplayType): any {
    return FormatService.convertNullValueToPreferredText(value, numbersDisplayType)
  }
}
